class RecentlyViewedProducts extends HTMLElement {
  async connectedCallback() {
    const key = 'kurti-recently-viewed';
    const current = this.dataset.productHandle;
    let handles = [];
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      handles = Array.isArray(stored) ? stored.filter((handle) => typeof handle === 'string' && handle !== current) : [];
      localStorage.setItem(key, JSON.stringify([current, ...handles].slice(0, 8)));
    } catch (error) { return; }
    const previous = handles.slice(0, 4);
    if (!previous.length) return;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const results = await Promise.allSettled(previous.map((handle) => fetch(`${root}products/${encodeURIComponent(handle)}.js`).then((response) => response.ok ? response.json() : null)));
      const products = results.filter((result) => result.status === 'fulfilled' && result.value).map((result) => result.value);
      if (!products.length) return;
      const escape = (text) => String(text).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency }).format;
      this.innerHTML = `<section><h2 class="title h1">${escape(this.dataset.heading)}</h2><div class="kurti-recently-viewed__grid">${products.map((product) => `<a class="kurti-recently-viewed__card" href="${encodeURI(product.url)}"><img src="${encodeURI(product.featured_image)}" alt="${escape(product.title)}" loading="lazy"><span>${escape(product.title)}</span><strong>${money(product.price / 100)}</strong></a>`).join('')}</div></section>`;
      this.hidden = false;
    } catch (error) {}
  }
}
customElements.define('recently-viewed-products', RecentlyViewedProducts);
